import React, { memo, useState } from 'react'
import tw from 'twin.macro'
import { maskAccountNumber } from 'src/utils/paymentsOps/maskAccountNumber'

interface Props {
  value?: string
  label: string
}

/**
 * The list returns FULL decrypted routing/account numbers. Masked by default; Reveal is per cell,
 * kept in component state only, and forgotten on unmount.
 */
const RevealableNumberComponent = ({ value, label }: Props) => {
  const [isRevealed, setIsRevealed] = useState<boolean>(false)

  if (!value) {
    return <span>—</span>
  }

  return (
    <span css={tw`flex flex-row items-center gap-2`}>
      <span css={tw`font-mono text-xs`}>{isRevealed ? value : maskAccountNumber(value)}</span>
      <button
        type="button"
        aria-label={`${isRevealed ? 'Hide' : 'Reveal'} ${label}`}
        onClick={(event) => {
          event.stopPropagation()
          setIsRevealed((previous) => {
            return !previous
          })
        }}
        css={tw`cursor-pointer border-0 bg-transparent p-0 text-xs font-semibold text-primary-700`}
      >
        {isRevealed ? 'Hide' : 'Reveal'}
      </button>
    </span>
  )
}

export const RevealableNumber = memo(RevealableNumberComponent)
